module.exports = __webpack_public_path__ + "static/media/microscopy-yliv-01 6.d733d8d0.png";